import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Button, Box, Typography, IconButton, GRAY } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import { ChevronLeftOutlineIcon, ChevronRightOutlineIcon } from '@applyboard/ui-icons';
import { CarouselWrapper, StyledCardTitle, StyledCardContent, StyledContentTitle } from "./style";
import carouselContent from "./data/content.json";
var SLIDER_INTERVAL = 10000;
var CardCarousel = function CardCarousel(_ref) {
  var _ref$cardsContent = _ref.cardsContent,
    cardsContent = _ref$cardsContent === void 0 ? carouselContent : _ref$cardsContent;
  var timer = useRef();
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentSlide = _useState2[0],
    setCurrentSlide = _useState2[1];
  var onNext = useCallback(function () {
    if (currentSlide >= cardsContent.length - 1) {
      setCurrentSlide(0);
      trackEvent({
        event: 'Agent Dashboard - Clicked Next Page',
        data: {
          date: new Date(),
          pageNavigatedTo: cardsContent[0].title,
          pageNavigatedFrom: cardsContent[cardsContent.length - 1].title
        }
      });
    } else {
      var _cardsContent;
      var previousSlide = currentSlide;
      setCurrentSlide(currentSlide + 1);
      trackEvent({
        event: 'Agent Dashboard - Clicked Next Page',
        data: {
          date: new Date(),
          pageNavigatedTo: (_cardsContent = cardsContent[currentSlide + 1]) === null || _cardsContent === void 0 ? void 0 : _cardsContent.title,
          pageNavigatedFrom: cardsContent[previousSlide].title
        }
      });
    }
  }, [currentSlide, cardsContent, trackEvent]);
  var onPrevious = useCallback(function () {
    if (currentSlide <= 0) {
      setCurrentSlide(cardsContent.length - 1);
      trackEvent({
        event: 'Agent Dashboard - Clicked Previous Page',
        data: {
          date: new Date(),
          pageNavigatedTo: cardsContent[cardsContent.length - 1].title,
          pageNavigatedFrom: cardsContent[0].title
        }
      });
    } else {
      var previousSlide = currentSlide;
      setCurrentSlide(currentSlide - 1);
      trackEvent({
        event: 'Agent Dashboard - Clicked Previous Page',
        data: {
          date: new Date(),
          pageNavigatedTo: cardsContent[currentSlide - 1].title,
          pageNavigatedFrom: cardsContent[previousSlide].title
        }
      });
    }
  }, [cardsContent, currentSlide, trackEvent]);
  var ctaTracker = useCallback(function () {
    trackEvent({
      event: 'Agent Dashboard - Clicked Feature Spotlight',
      data: {
        date: new Date(),
        title: cardsContent[currentSlide].title,
        description: cardsContent[currentSlide].description,
        cta: 'Learn More',
        ctaLink: cardsContent[currentSlide].ctaLink
      }
    });
  }, [trackEvent, currentSlide, cardsContent]);
  useEffect(function () {
    timer.current = setInterval(function () {
      return setCurrentSlide(function (prev) {
        return (prev + 1) % cardsContent.length;
      });
    }, SLIDER_INTERVAL);
    return function () {
      return clearInterval(timer.current);
    }; //clears the interval on component dismount
  }, [onNext, onPrevious, timer, cardsContent]);
  return /*#__PURE__*/React.createElement(CarouselWrapper, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    flex: "1"
  }, /*#__PURE__*/React.createElement(Box, {
    borderBottom: "1px solid ".concat(GRAY[18]),
    width: "100%",
    pl: 3
  }, /*#__PURE__*/React.createElement(StyledCardTitle, {
    m: 2
  }, "Spotlight")), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    height: "130px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement("img", {
    src: cardsContent[currentSlide].imageUrl,
    alt: cardsContent[currentSlide].title,
    height: "90%"
  })), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(StyledContentTitle, {
    mt: 2,
    ml: 3,
    mr: 3,
    mb: 1,
    align: "center"
  }, cardsContent[currentSlide].title)), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(StyledCardContent, {
    ml: 3,
    mr: 3,
    mb: 3,
    align: "center"
  }, cardsContent[currentSlide].description))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    mb: 2,
    height: "94px"
  }, /*#__PURE__*/React.createElement(Button, {
    href: cardsContent[currentSlide].ctaLink,
    variant: "contained",
    color: "primary",
    mt: "auto",
    onClick: ctaTracker,
    "data-testid": "cta-button"
  }, "Learn More"), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: 2
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: onPrevious,
    color: "inherit",
    "data-testid": "previous-button"
  }, /*#__PURE__*/React.createElement(ChevronLeftOutlineIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    mx: 2,
    my: 0,
    color: "secondary"
  }, currentSlide + 1, " of ", cardsContent.length), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: onNext,
    color: "inherit",
    "data-testid": "next-button"
  }, /*#__PURE__*/React.createElement(ChevronRightOutlineIcon, null))))));
};
export { CardCarousel };